import { render, staticRenderFns } from "./SliderMock.vue?vue&type=template&id=552e5ad0&"
import script from "./SliderMock.vue?vue&type=script&lang=ts&"
export * from "./SliderMock.vue?vue&type=script&lang=ts&"
import style0 from "./SliderMock.vue?vue&type=style&index=0&id=552e5ad0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports